module.exports = __webpack_public_path__ + "img/camera-movie.34e5c1a0.svg";